"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = require("styled-components");
var _oneflare = _interopRequireDefault(require("../../styles/styled-component/oneflare"));
var breakpoint = _oneflare.default.breakpoint;

// media is a collection of helpers that can be used within styled-components
// to simplify media queries. They are similar to Bootstrap's media classes.
// Up helpers apply styles for the given size and larger.
// Down helpers apply styles for the given size and smaller.
//
//  ====== Up styles
//   smUp
//   mdUp
//   lgUp
//   xlUp
//
//  ====== Down styles
//   xsDown
//   smDown
//   mdDown
//   lgDown
//
//  ====== Single size styles
//   sm
//   md
//   lg
//
// Example usage:
//
// const Example = styled.div`
//   media.mdDown`
//     color: green;
//   `
// `

var media = Object.keys(breakpoint).reduce(function (accumulator, label) {
  var down = breakpoint[label].min;
  var up = breakpoint[label].max;

  // conditional to omit reduntant xlDown
  if (down) {
    accumulator["".concat(label, "Down")] = function () {
      return (0, _styledComponents.css)(["@media (max-width:", "){", "}"], down, _styledComponents.css.apply(void 0, arguments));
    };
  }

  // conditional to omit reduntant xsUp
  if (up) {
    // eslint-disable-next-line no-param-reassign
    accumulator["".concat(label, "Up")] = function () {
      return (0, _styledComponents.css)(["@media (min-width:", "){", "}"], up, _styledComponents.css.apply(void 0, arguments));
    };
  }
  if (down && up) {
    // eslint-disable-next-line no-param-reassign
    accumulator["".concat(label)] = function () {
      return (0, _styledComponents.css)(["@media (min-width:", ") and (max-width:", "){", "}"], down, up, _styledComponents.css.apply(void 0, arguments));
    };
  }
  return accumulator;
}, {});
var _default = exports.default = media;